import { Directive, ElementRef, NgZone } from "@angular/core";
import { numberColorMap } from "../shared/directives/number-color/number-color-constants";
import fastdom from "fastdom";
import { Dictionary } from "lodash";

@Directive({
    selector: "[game-number-color]"
})
export class GameNumberColorDirective {
    private readonly colorsMap: Dictionary<string> = {};

    constructor(private elementRef: ElementRef,
                private ngZone: NgZone) {
        for (let color in numberColorMap) {
            this.colorsMap = { [numberColorMap[color].end]: color, ...this.colorsMap };
        }
        this.colorsMap = Object.keys(this.colorsMap)
            .sort((a, b) => {
                return parseFloat(a) > parseFloat(b) ? 1 : -1;
            })
            .reduce((obj, key) => {
                obj[key] = this.colorsMap[key];
                return obj;
            }, {});
    }

    onMultiplierUpdate(multiplier: number): void {
        this.ngZone.runOutsideAngular(() => {
            fastdom.mutate(() => {
                if (multiplier % 1 >= 0 && multiplier % 1 <= 0.1) {
                    this.elementRef.nativeElement.classList.add("pulse-jump-animation");
                } else {
                    this.elementRef.nativeElement.classList.remove("pulse-jump-animation");
                }

                for (let endNumber in this.colorsMap) {
                    if (multiplier <= parseFloat(endNumber)) {
                        this.elementRef.nativeElement.style.backgroundColor = this.colorsMap[endNumber];
                        break;
                    }
                }
            });
        });
    }
}
